import App from './App'

document.addEventListener('DOMContentLoaded', () => new App())
